exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2gzcgThAIddlNg5PijIrED{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;font-size:12px;font-weight:400;color:\"[theme:themeDark, default:#0D62AA]\"}html[dir] ._2gzcgThAIddlNg5PijIrED{padding:5px 14px;-webkit-box-shadow:0 0 1px 0 \"[theme:neutralTertiaryAlt, default:#c8c8c8]\";box-shadow:0 0 1px 0 \"[theme:neutralTertiaryAlt, default:#c8c8c8]\";border-radius:11.5px;background:\"[theme:white, default:#ffffff]\"}._1zdkbzhJ5NJyP7koRBM6Fo{font-size:12px;font-weight:400}html[dir=ltr] ._1zdkbzhJ5NJyP7koRBM6Fo{padding-right:6px}html[dir=rtl] ._1zdkbzhJ5NJyP7koRBM6Fo{padding-left:6px}", ""]);

// exports
exports.locals = {
	"innerContainer": "_2gzcgThAIddlNg5PijIrED",
	"clockIcon": "_1zdkbzhJ5NJyP7koRBM6Fo"
};